// White surface card used to wrap individual blocks (charts, tables) within a section. Sections
// themselves are transparent — the background lives on the parts, not the whole section.
import React, { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface DashboardCardProps {
  children: ReactNode;
  className?: string;
}

const DashboardCard: React.FC<DashboardCardProps> = ({ children, className }) => (
  <div className={twMerge('bg-white rounded-lg p-6 shadow-[0px_2px_8px_0px_rgba(0,0,0,0.05),0px_16px_48px_0px_rgba(254,80,0,0.02)]', className)}>{children}</div>
);

export default DashboardCard;